// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mobile first styles */

header {
  --page-padding: var(--page-padding-mobile);
  --page-delta-padding: var(--page-delta-padding-mobile);
  --h1-padding: var(--h1-padding-mobile);

  --footer-bg-poligon: var(--footer-bg-poligon-mobile);

  --full-padding: calc(var(--page-padding) + var(--page-delta-padding));

  display: grid;
  grid-template-columns: var(--page-delta-padding) 1fr var(--page-delta-padding);
  grid-template-rows:
    var(--page-delta-padding) minmax(0, 1fr)
    var(--full-padding) max-content;

  height: 100vh;
  height: 100dvh;
  min-height: min-content;
  padding: var(--page-padding);

  position: relative;
}

header::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;

  clip-path: var(--footer-bg-poligon);
  background: var(--header-linear-gradient);
}

header h1 {
  grid-row: 2;
  grid-column: 2;
  z-index: 3;

  align-self: end;
  justify-self: start;
  font-size: var(--h1-fontsize);
  font-family: var(--h1-font);
  color: var(--col-txt-alt);
  text-shadow: var(--txt-shadow);
  padding: var(--h1-padding);
  font-weight: bold;
  line-height: 0.9;
  text-align: center;
  margin: 0 auto;
}

header img {
  grid-row: 2;
  grid-column: 2;
  z-index: 2;

  width: 100%;

  /* make the height 0 to not affect the layout (row height), 
  and force min-height to100% to take the row height
  see: https://stackoverflow.com/questions/63726048/prevent-image-from-being-used-to-calculate-grid-row-height */
  height: 0;
  min-height: 100%;

  object-fit: cover;
  box-shadow: var(--box-shadow-darker);

  background-color: rgb(32, 5, 1);
}

header .about-me {
  grid-row: 4;
  grid-column: 1 / span 3;
  z-index: 1;
}

/* mobile, horizontal */
@media only screen and (max-height: 550px) and (orientation: landscape) {
  header {
    --page-delta-padding: 0;
    --footer-bg-poligon: var(--footer-bg-poligon-mobile-landscape);

    grid-template-columns: 0.8fr 1fr;
    grid-template-rows: minmax(0, 1fr);
  }

  header h1 {
    grid-row: 1;
    grid-column: 1;
  }

  header img {
    grid-row: 1;
    grid-column: 1;
  }

  header .about-me {
    grid-row: 1;
    grid-column: 2;
  }
}

/* tablet or larger */
@media only screen and (min-width: 767px) and (min-height: 551px) {
  header {
    --page-padding: var(--page-padding-tablet);
    --page-delta-padding: var(--page-delta-padding-tablet);
    --h1-padding: var(--h1-padding-tablet);

    --footer-bg-poligon: var(--footer-bg-poligon-tablet);

    --h1-height: calc(
      var(--h1-padding-top-tablet) + var(--h1-padding-bottom-tablet) +
        var(--txt-lineheight) * var(--h1-fontsize)
    );

    --portrait-inner-width: calc(50% - 2 * var(--page-delta-padding));

    --portrait-float-space-height: calc(
      var(--txt-lineheight) * (var(--h2-fontsize) + 4 * var(--txt-fontsize)) +
        var(--about-me-description-padding-top-tablet) +
        var(--about-me-padding-top-tablet)
    );

    grid-template-columns:
      var(--page-delta-padding) var(--portrait-inner-width)
      var(--page-delta-padding) 1fr var(--page-delta-padding);

    grid-template-rows:
      minmax(0, 1fr) var(--h1-height)
      var(--portrait-float-space-height)
      min-content minmax(0, 1fr);
  }

  header h1 {
    grid-row: 2;
    grid-column: 1 / span 5;
    justify-self: end;
    margin: 0;
  }

  header img {
    grid-row: 2 / span 2;
    grid-column: 1 / span 3;
  }

  header .about-me {
    grid-row: 3 / span 2;
    grid-column: 2 / span 3;
  }

  header .about-me {
    background-color: var(--bg-col);
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  header {
    --page-padding: var(--page-padding-desktop);
    --page-delta-padding: var(--page-delta-padding-desktop);
    --h1-padding: var(--h1-padding-desktop);

    --footer-bg-poligon: var(--footer-bg-poligon-desktop);

    grid-template-columns:
      0.8fr var(--page-delta-padding-desktop)
      1fr;

    grid-template-rows: var(--page-delta-padding-desktop) minmax(0, 1fr) var(
        --page-delta-padding-desktop
      );
  }

  header h1 {
    grid-row: 1 / span 3;
    grid-column: 1 / span 2;
    justify-self: end;
    margin: 0 auto;
  }

  header img {
    grid-row: 1 / span 3;
    grid-column: 1 / span 2;
  }

  header .about-me {
    grid-row: 2;
    grid-column: 2 / span 2;
  }
}

/* Hover styles */

/* when hover is supported */
@media not all and (hover: none) {
  header img:hover,
  header h1:hover + img {
    object-fit: contain;
  }
}

header img:active,
header h1:active + img {
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/header.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,0CAA0C;EAC1C,sDAAsD;EACtD,sCAAsC;;EAEtC,oDAAoD;;EAEpD,qEAAqE;;EAErE,aAAa;EACb,8EAA8E;EAC9E;;mCAEiC;;EAEjC,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,4BAA4B;;EAE5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;;EAEV,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;;EAEV,WAAW;;EAEX;;gHAE8G;EAC9G,SAAS;EACT,gBAAgB;;EAEhB,iBAAiB;EACjB,oCAAoC;;EAEpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE;IACE,uBAAuB;IACvB,8DAA8D;;IAE9D,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,0CAA0C;IAC1C,sDAAsD;IACtD,sCAAsC;;IAEtC,oDAAoD;;IAEpD;;;KAGC;;IAED,iEAAiE;;IAEjE;;;;KAIC;;IAED;;6DAEyD;;IAEzD;;;gCAG4B;EAC9B;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,2CAA2C;IAC3C,uDAAuD;IACvD,uCAAuC;;IAEvC,qDAAqD;;IAErD;;SAEK;;IAEL;;OAEG;EACL;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,iBAAiB;;AAEjB,4BAA4B;AAC5B;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":["/* mobile first styles */\r\n\r\nheader {\r\n  --page-padding: var(--page-padding-mobile);\r\n  --page-delta-padding: var(--page-delta-padding-mobile);\r\n  --h1-padding: var(--h1-padding-mobile);\r\n\r\n  --footer-bg-poligon: var(--footer-bg-poligon-mobile);\r\n\r\n  --full-padding: calc(var(--page-padding) + var(--page-delta-padding));\r\n\r\n  display: grid;\r\n  grid-template-columns: var(--page-delta-padding) 1fr var(--page-delta-padding);\r\n  grid-template-rows:\r\n    var(--page-delta-padding) minmax(0, 1fr)\r\n    var(--full-padding) max-content;\r\n\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  min-height: min-content;\r\n  padding: var(--page-padding);\r\n\r\n  position: relative;\r\n}\r\n\r\nheader::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  clip-path: var(--footer-bg-poligon);\r\n  background: var(--header-linear-gradient);\r\n}\r\n\r\nheader h1 {\r\n  grid-row: 2;\r\n  grid-column: 2;\r\n  z-index: 3;\r\n\r\n  align-self: end;\r\n  justify-self: start;\r\n  font-size: var(--h1-fontsize);\r\n  font-family: var(--h1-font);\r\n  color: var(--col-txt-alt);\r\n  text-shadow: var(--txt-shadow);\r\n  padding: var(--h1-padding);\r\n  font-weight: bold;\r\n  line-height: 0.9;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n}\r\n\r\nheader img {\r\n  grid-row: 2;\r\n  grid-column: 2;\r\n  z-index: 2;\r\n\r\n  width: 100%;\r\n\r\n  /* make the height 0 to not affect the layout (row height), \r\n  and force min-height to100% to take the row height\r\n  see: https://stackoverflow.com/questions/63726048/prevent-image-from-being-used-to-calculate-grid-row-height */\r\n  height: 0;\r\n  min-height: 100%;\r\n\r\n  object-fit: cover;\r\n  box-shadow: var(--box-shadow-darker);\r\n\r\n  background-color: rgb(32, 5, 1);\r\n}\r\n\r\nheader .about-me {\r\n  grid-row: 4;\r\n  grid-column: 1 / span 3;\r\n  z-index: 1;\r\n}\r\n\r\n/* mobile, horizontal */\r\n@media only screen and (max-height: 550px) and (orientation: landscape) {\r\n  header {\r\n    --page-delta-padding: 0;\r\n    --footer-bg-poligon: var(--footer-bg-poligon-mobile-landscape);\r\n\r\n    grid-template-columns: 0.8fr 1fr;\r\n    grid-template-rows: minmax(0, 1fr);\r\n  }\r\n\r\n  header h1 {\r\n    grid-row: 1;\r\n    grid-column: 1;\r\n  }\r\n\r\n  header img {\r\n    grid-row: 1;\r\n    grid-column: 1;\r\n  }\r\n\r\n  header .about-me {\r\n    grid-row: 1;\r\n    grid-column: 2;\r\n  }\r\n}\r\n\r\n/* tablet or larger */\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  header {\r\n    --page-padding: var(--page-padding-tablet);\r\n    --page-delta-padding: var(--page-delta-padding-tablet);\r\n    --h1-padding: var(--h1-padding-tablet);\r\n\r\n    --footer-bg-poligon: var(--footer-bg-poligon-tablet);\r\n\r\n    --h1-height: calc(\r\n      var(--h1-padding-top-tablet) + var(--h1-padding-bottom-tablet) +\r\n        var(--txt-lineheight) * var(--h1-fontsize)\r\n    );\r\n\r\n    --portrait-inner-width: calc(50% - 2 * var(--page-delta-padding));\r\n\r\n    --portrait-float-space-height: calc(\r\n      var(--txt-lineheight) * (var(--h2-fontsize) + 4 * var(--txt-fontsize)) +\r\n        var(--about-me-description-padding-top-tablet) +\r\n        var(--about-me-padding-top-tablet)\r\n    );\r\n\r\n    grid-template-columns:\r\n      var(--page-delta-padding) var(--portrait-inner-width)\r\n      var(--page-delta-padding) 1fr var(--page-delta-padding);\r\n\r\n    grid-template-rows:\r\n      minmax(0, 1fr) var(--h1-height)\r\n      var(--portrait-float-space-height)\r\n      min-content minmax(0, 1fr);\r\n  }\r\n\r\n  header h1 {\r\n    grid-row: 2;\r\n    grid-column: 1 / span 5;\r\n    justify-self: end;\r\n    margin: 0;\r\n  }\r\n\r\n  header img {\r\n    grid-row: 2 / span 2;\r\n    grid-column: 1 / span 3;\r\n  }\r\n\r\n  header .about-me {\r\n    grid-row: 3 / span 2;\r\n    grid-column: 2 / span 3;\r\n  }\r\n\r\n  header .about-me {\r\n    background-color: var(--bg-col);\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  header {\r\n    --page-padding: var(--page-padding-desktop);\r\n    --page-delta-padding: var(--page-delta-padding-desktop);\r\n    --h1-padding: var(--h1-padding-desktop);\r\n\r\n    --footer-bg-poligon: var(--footer-bg-poligon-desktop);\r\n\r\n    grid-template-columns:\r\n      0.8fr var(--page-delta-padding-desktop)\r\n      1fr;\r\n\r\n    grid-template-rows: var(--page-delta-padding-desktop) minmax(0, 1fr) var(\r\n        --page-delta-padding-desktop\r\n      );\r\n  }\r\n\r\n  header h1 {\r\n    grid-row: 1 / span 3;\r\n    grid-column: 1 / span 2;\r\n    justify-self: end;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  header img {\r\n    grid-row: 1 / span 3;\r\n    grid-column: 1 / span 2;\r\n  }\r\n\r\n  header .about-me {\r\n    grid-row: 2;\r\n    grid-column: 2 / span 2;\r\n  }\r\n}\r\n\r\n/* Hover styles */\r\n\r\n/* when hover is supported */\r\n@media not all and (hover: none) {\r\n  header img:hover,\r\n  header h1:hover + img {\r\n    object-fit: contain;\r\n  }\r\n}\r\n\r\nheader img:active,\r\nheader h1:active + img {\r\n  object-fit: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
